import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { filter, map, switchMap, take, withLatestFrom } from 'rxjs';

import { ContainerMeasurement } from 'app/features/manual-input-result-registration/models/container-measurement';
import { sendTransformedScanFlowRegistrationDataSuccess } from 'app/features/scan-flow/state/scan-flow/scan-flow-labor-registration/scan-flow-labor-registration.actions';
import {
    addContainerMeasurementsToCache,
    showingToastAfterContainerMeasurement,
} from 'app/state/container-measurements/container-measurements.actions';

import { selectScanFlowRegistrationData } from '../scan-flow.selectors';
import {
    sendCurrentScanFlowContainerMeasurementData,
    sendTransformedScanFlowContainerMeasurementData,
} from './scan-flow-result-registration.actions';
import { transformScanFlowContainerMeasurementData } from './scan-flow-result-registration.selectors';

// noinspection JSUnusedGlobalSymbols
@Injectable()
export class ScanFlowResultRegistrationEffects {
    sendCurrentScanFlowContainerMeasurementData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(sendCurrentScanFlowContainerMeasurementData),
            withLatestFrom(this.store.select(selectScanFlowRegistrationData)),
            map(([{ registrationTimestamp }, registrationData]) => {
                return sendTransformedScanFlowContainerMeasurementData({
                    registrationData,
                    registrationTimestamp,
                    onSuccessAction: undefined,
                });
            }),
        ),
    );

    sendTransformedScanFlowContainerMeasurementData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(sendTransformedScanFlowContainerMeasurementData),
            switchMap(({ registrationData, registrationTimestamp, onSuccessAction }) =>
                this.store.pipe(
                    transformScanFlowContainerMeasurementData({
                        registrationData,
                        registrationTimestamp,
                    }),
                    take(1),
                    filter(
                        (containerMeasurement): containerMeasurement is ContainerMeasurement =>
                            !!containerMeasurement,
                    ),
                    map((containerMeasurement) => ({
                        containerMeasurement,
                        registrationData,
                        onSuccessAction,
                    })),
                ),
            ),
            switchMap(({ containerMeasurement, registrationData, onSuccessAction }) => {
                let nextActions: Action[] = [
                    addContainerMeasurementsToCache({ containerMeasurements: [containerMeasurement] }),
                    showingToastAfterContainerMeasurement({ containerMeasurements: [containerMeasurement] }),
                    sendTransformedScanFlowRegistrationDataSuccess({
                        registrationData,
                    }),
                ];

                if (onSuccessAction) nextActions = [...nextActions, onSuccessAction];

                return nextActions;
            }),
        ),
    );

    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
